"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEthersSigner = exports.walletClientToSigner = exports.getEthersProvider = exports.publicClientToProvider = void 0;
// import {
//   type PublicClient,
//   type WalletClient,
//   // getPublicClient,
//   // getWalletClient,
// } from '@wagmi/core';
// import { getPublicClient, getWalletClient, getNetwork, switchNetwork } from 'wagmi/actions';
// import { polygonMumbai, bsc, fuse } from '@wagmi/core/chains';
const ethers_1 = require("ethers");
let wagmiCore;
let chains;
function loadWagmiCore() {
    return __awaiter(this, void 0, void 0, function* () {
        // wagmiCore = await import('@wagmi/core');
        wagmiCore = yield Promise.resolve().then(() => __importStar(require('wagmi/actions')));
        chains = yield Promise.resolve().then(() => __importStar(require('@wagmi/core/chains')));
    });
}
function publicClientToProvider(publicClient) {
    var _a, _b;
    const { chain, transport } = publicClient;
    const network = {
        chainId: chain === null || chain === void 0 ? void 0 : chain.id,
        name: chain === null || chain === void 0 ? void 0 : chain.name,
        ensAddress: (_b = (_a = chain.contracts) === null || _a === void 0 ? void 0 : _a.ensRegistry) === null || _b === void 0 ? void 0 : _b.address,
    };
    if (transport.type === 'fallback')
        return new ethers_1.providers.FallbackProvider(transport.transports.map(({ value }) => new ethers_1.providers.JsonRpcProvider(value === null || value === void 0 ? void 0 : value.url, network)));
    return new ethers_1.providers.JsonRpcProvider(transport.url, network);
}
exports.publicClientToProvider = publicClientToProvider;
/** Action to convert a viem Public Client to an ethers.js Provider. */
function getEthersProvider({ chainId }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!wagmiCore) {
            yield loadWagmiCore();
        }
        const publicClient = yield wagmiCore.getPublicClient({ chainId });
        return publicClientToProvider(publicClient);
    });
}
exports.getEthersProvider = getEthersProvider;
function walletClientToSigner(walletClient, chainData) {
    var _a, _b;
    const { account, chain: chainWc, transport } = walletClient;
    console.log('walletClientToSigner', { account, chainWc, transport });
    let chain;
    if (chainWc)
        chain = chainWc;
    else if (chainData)
        chain = chainData;
    const network = {
        chainId: chain.id,
        name: chain.name,
        ensAddress: (_b = (_a = chain.contracts) === null || _a === void 0 ? void 0 : _a.ensRegistry) === null || _b === void 0 ? void 0 : _b.address,
    };
    const provider = new ethers_1.providers.Web3Provider(transport, network);
    const signer = provider.getSigner(account.address);
    return signer;
}
exports.walletClientToSigner = walletClientToSigner;
/** Action to convert a viem Wallet Client to an ethers.js Signer. */
function getEthersSigner({ chainId }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!wagmiCore || !chains) {
            yield loadWagmiCore();
        }
        console.log({ walletClientChainId: chainId });
        const { chain } = yield wagmiCore.getNetwork();
        if ((chain === null || chain === void 0 ? void 0 : chain.id) !== chainId)
            yield wagmiCore.switchNetwork({ chainId });
        let chainData;
        if (chainId == 122)
            chainData = chains.fuse;
        else if (chainId == 80001)
            chainData = chains.polygonMumbai;
        const walletClient = yield wagmiCore.getWalletClient({ chainId });
        if (!walletClient)
            return undefined;
        return walletClientToSigner(walletClient, chainData);
    });
}
exports.getEthersSigner = getEthersSigner;
